<template>
    <div class="modal fade cs-fade" id="view_record_qr_modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-fullscreen-sm-down">
            <div class="modal-content">
                <!-- <div class="modal-header">
                    <h1 class="modal-title fs-3 fw-bold" v-if="title">{{ title }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div> -->
                <div class="modal-body">
                    <img :src="qr_src" class="d-block w-100" />
                    <br />
                    <div class="text-center">
                        <h5 class="cs-text-gradient">{{ qr_content }}</h5>
                        <p>Show this QR code to the merchant to redeem voucher</p>
                    </div>
                    <br />
                    <div class="d-grid gap-2 mb-2">
                        <button @click="$parent.closeModal()" class="btn btn-secondary">Close</button>
                    </div>
                    <!-- <slot></slot> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title: String,
        qr_src: String,
        qr_content: String,
    },
    data() {
        return {
        };
    },
    mounted() {

    },
    methods: {
    },
};
</script>
